import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.wizard.PersonsSettingsStep.StepForm', {
    selectOwner: 'Please select owner to complete data verification',
    selectOwnerTooltip:
        'We need to verify personal data for one of your company directors and one of your company owners. Please select whose data should be verified.',
    selectDirector: 'Please select director who will be assigned as wallet owner',
    noticeOnlyWalletOwnerCanHaveAccess: 'Only wallet owner will initially have access to the wallets;',
    noticeByDefault: 'By default you will NOT be granted access to the wallets after KYC is completed;',
    noticeOnlyWalletOwnerCanGrantAccess: 'Only wallet owner can grant access to the wallets for users in your company.',
});
